import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { firestore } from '../../firebase'

function AuthorsList() {

    const [authors, setAuthors] = useState([])

    useEffect(() => {

        async function fetchAuthors() {

            try {
                const authorsRef = firestore.collection("authors");
                authorsRef.onSnapshot(({docs}) => {
                    const authors = docs.map(doc => {
                        return {id: doc.id, ...doc.data()}
                    })
                    setAuthors(authors);
                })
            } catch (error) {
                
            }

        }
        fetchAuthors()

    }, [])

    return (
        <div className="container my-4">
            {authors && authors.map((author, index) => {
                return (
                    <div className="card my-2" key={index}>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-3 col-md-2 col-lg-1">
                                    <img src={author.profile_image} alt={author.name} className="img-fluid rounded-circle" />
                                </div>
                                <div className="col-9 col-md-10 col-lg-11">
                                    <Link to={`/member/${author.user_id}`}>{author.name}</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}


        </div>
    )
}
export default AuthorsList